/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_MenuInputs */

const cs_pwa_install_menu = /** @type {(inputs: Pwa_Install_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nainstalovat aplikaci`)
};

const en_pwa_install_menu = /** @type {(inputs: Pwa_Install_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install app`)
};

/**
* | output |
* | --- |
* | "Install app" |
*
* @param {Pwa_Install_MenuInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_menu = /** @type {((inputs?: Pwa_Install_MenuInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_MenuInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_menu(inputs)
	return cs_pwa_install_menu(inputs)
});